/**
 * @des 获取浏览器名称和版本号
 */
const browserList = [
  {
    bs_name: '火狐浏览器',
    bs_tag: 'firefox'
  },
  {
    bs_name: 'edge浏览器',
    bs_tag: 'edg'
  },
  {
    bs_name: 'opera',
    bs_tag: 'opr'
  },
  {
    bs_name: '世界之窗',
    bs_tag: 'theworld'
  },
  {
    bs_name: '遨游',
    bs_tag: 'maxthon'
  },
  {
    bs_name: 'QQ浏览器',
    bs_tag: 'qqbrowser'
  },
  {
    bs_name: '360浏览器',
    bs_tag: '360'
  },
  {
    bs_name: '搜狗浏览器',
    bs_tag: 'metasr'
  },
  {
    bs_name: 'uc浏览器',
    bs_tag: 'ubrowse'
  },
  {
    bs_name: '猎豹',
    bs_tag: 'lbbrowser'
  },
  {
    bs_name: '微信浏览器',
    bs_tag: 'micromessenger'
  },
  {
    bs_name: '小米浏览器',
    bs_tag: 'miuibrowser'
  },
  {
    bs_name: '百度浏览器',
    bs_tag: 'baidu'
  },
  {
    bs_name: '2345浏览器',
    bs_tag: '2345explorer'
  },
  {
    bs_name: 'IE浏览器',
    bs_tag: 'msie'
  },
  {
    bs_name: 'IE11浏览器',
    bs_tag: 'rv:11.0'
  }
]
const userAgent = navigator.userAgent.toLowerCase()
const userAgentData = navigator.userAgentData || { brands: [] }

// 获取浏览器的版本号，如果没有则获取chrome标识的版本号
const getBsVersion = tag => {
  const browser =
    userAgent
      .split(' ')
      .find(item => item?.indexOf(tag) > -1)
      ?.split('/') || []
  return browser[1] || ''
}
/**
 * @description 判断是否是遨游浏览器
 * @returns boolean
 */
const isMaxthon = () => {
  return window.maxthon
}
/**
 * @description 判断是否是360浏览器，360浏览器userAgent返回的信息与chrome基本一致，无法简单通过信息判断
 * @returns boolean
 */
const is360 = () => {
  const result = false
  for (var key in navigator.plugins) {
    if (navigator.plugins[key].filename == 'internal-nacl-plugin') {
      return !result
    }
  }
  return result
}
// 获取浏览器信息
const getBsInfo = (list = []) => {
  try {
    if (isMaxthon()) {
      return {
        bs_name: '遨游浏览器',
        bs_tag: 'maxthon',
        bs_version: getBsVersion('chrome')
      }
    }
    if (userAgentData.brands.some(item => item.brand === 'Google Chrome')) {
      return {
        bs_name: 'chrome浏览器',
        bs_tag: 'chrome',
        bs_version: getBsVersion('chrome')
      }
    }
    if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
      return {
        bs_name: 'safari浏览器',
        bs_tag: 'safari',
        bs_version: getBsVersion('safari')
      }
    }
    const isBrowser = browserList.concat(list).find(item => userAgent.indexOf(item.bs_tag) > -1)
    if (isBrowser) {
      return {
        bs_name: isBrowser.bs_name,
        bs_tag: isBrowser.bs_tag,
        bs_version: getBsVersion(isBrowser.bs_tag)
      }
    } else if (userAgent.indexOf('camcardenterprise') > -1) {
      return {
        bs_name: 'ccbApp',
        bs_tag: 'ccbApp',
        bs_version: getBsVersion('camcardenterprise')
      }
    } else if (userAgent.indexOf('camcard') > -1) {
      return {
        bs_name: 'camcardApp',
        bs_tag: 'camcard',
        bs_version: getBsVersion('camcard')
      }
    } else {
      if (is360()) {
        return {
          bs_name: '360浏览器',
          bs_tag: '360',
          bs_version: getBsVersion('chrome')
        }
      } else if (userAgent.indexOf('chrome') > -1) {
        return {
          bs_name: '其他浏览器',
          bs_tag: 'chrome内核',
          bs_version: getBsVersion('chrome')
        }
      }
      return {
        bs_name: '未知浏览器',
        bs_tag: 'other',
        bs_version: ''
      }
    }
  } catch (error) {
    console.log(error)
    return {
      bs_name: '未知浏览器error',
      bs_tag: 'other',
      bs_version: ''
    }
  }
}
export default getBsInfo
